"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuEventType = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var MenuEventType;
(function (MenuEventType) {
    MenuEventType["MENU_OPEN"] = "\uD83D\uDE80 menu.open";
    MenuEventType["MENU_CLOSE"] = "\uD83D\uDE80 menu.close";
    MenuEventType["MENU_SCROLL"] = "\uD83D\uDE80 menu.scroll";
    MenuEventType["MENU_EXPAND"] = "\uD83D\uDE80 menu.expand";
    MenuEventType["MENU_COLLAPSE"] = "\uD83D\uDE80 menu.collapse";
    MenuEventType["MENU_ACTION"] = "\uD83D\uDE80 menu.action";
})(MenuEventType || (exports.MenuEventType = MenuEventType = {}));
const trackMenu = (action) => {
    switch (action.type) {
        case MenuEventType.MENU_OPEN:
        case MenuEventType.MENU_CLOSE:
        case MenuEventType.MENU_SCROLL:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: {},
                _clear: true,
            });
            break;
        case MenuEventType.MENU_EXPAND:
        case MenuEventType.MENU_COLLAPSE:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: {
                    position: (action.payload.position + 1).toString(),
                    label: action.payload.label,
                },
                _clear: true,
            });
            break;
        case MenuEventType.MENU_ACTION:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: {
                    position: typeof action.payload.position === 'number'
                        ? (action.payload.position + 1).toString()
                        : action.payload.position.map(i => i + 1).join('.'),
                    link: action.payload.link,
                },
                _clear: true,
            });
    }
};
exports.default = trackMenu;
//# sourceMappingURL=index.js.map